import {getFeaturesFromParent} from "../handler/ParentDataHandler";
import {chainWalk} from "./Util";

export const FEATURES = {
    IS_ADTA_HAMPER_ZONING_ENABLED: "isADTAHamperZoningEnabled",
    IS_ADTF_SUBTYPE_ENABLED: "isADTFSubtypeEnabled",
    IS_DMW_PERMISSIONS_ENABLED: "isDMWPermissionsEnabled",
    IS_MHE_VALIDATION_ENABLED: "isMHEValidationEnabled",
    IS_RFID_BAGS_ENABLED: "isRFIDBagsEnabled",
    IS_SSD_2_X_ENABLED: "isSSD2XEnabled",
    IS_SSD3_ENABLED: "isSSD3Enabled",
    IS_LED_CONTROLLER_ENHANCEMENT_ENABLED: "isLedControllerEnhancementEnabled",
    IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED: "isNewZancasortTestConfigEnabled",
    IS_MULTIPLE_BULKY_SLIDES_FOR_DROP_TO_CART_ENABLED: "isMultipleBulkySlidesForDropToCartEnabled",
    IS_MULTIPLE_FRAGILE_SLIDES_ENABLED_FOR_SSD: "isMultipleFragileSlidesForSSDEnabled",
    IS_PROBLEM_SOLVE_ON_GRID_SORTATION_FLOW_ENABLED: "isPSOnGridSortationFlowEnabled",
    IS_BIN_INSTALLATION_TYPE_ENABLED: "isBinInstallationTypeEnabled",
    IS_ADTA_DEVICE_HEALTH_STATUS_API_ENABLED: "isAdtaDeviceHealthStatusAPIEnabled"
}

/**
 * Use this class whenever there is a requirement whenever a feature context variable
 * is required to be used for both components and other objects.
 */
export class FeatureUtility {
    static featureStatus = {};

    static getFeatureStatus(featureName) {
        return chainWalk(() => FeatureUtility.featureStatus[featureName], false);
    }

    static setAllFeatureStatuses() {
        return getFeaturesFromParent(Object.values(FEATURES)).then(featureStatusResponse => {
            Object.values(FEATURES).forEach((featureName) => {
                FeatureUtility.featureStatus[featureName] =
                    chainWalk(() => featureStatusResponse.data[featureName], false)
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/util/FeatureUtility.js